import styled from '~/utils/styled';
// ---- external imports ----

import Asset from '~/containers/GameAsset';
import { PointerCursor, DeniedCursor } from '~/containers/GameAsset/cursors';
import btnPlayImg from '~/assets/images/auth/btn-play.png';
import checkImg from '~/assets/images/auth/check.png';
// ---- internal imports ----


// region [Projection Constants]
export const EMAIL_INPUT_PROJECTION = { width: 632, height: 76 };
export const PASSWORD_INPUT_PROJECTION = { width: 632, height: 76 };
export const FORGOT_PASSWORD_PROJECTION = { width: 216 };
const CHECKBOX_PROJECTION = { width: 32, height: 32 };
const REMEMBER_ME_PROJECTION = { width: 180 };
const PLAY_BTN_TEXT_PROJECTION = { width: 149 };
// endregion

// region [Components]

export const CheckboxBackground = styled(Asset.Backdrop.withProps({
	projection: CHECKBOX_PROJECTION,
}))`
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	box-shadow: inset 0 0 17px 0 rgba(0, 0, 0, 0.25);
`;

export const CheckboxInput = styled(Asset.Input.withProps({
	projection: CHECKBOX_PROJECTION,
}))`
	opacity: 0;
	${PointerCursor};
	z-index: 1;

	&:disabled {
		${DeniedCursor};
	};
`;

export const CheckmarkImage = Asset.Img.withProjection(checkImg);

export const RememberMeText = styled(Asset.Text.withProps({
	fontSize: 24,
	projection: REMEMBER_ME_PROJECTION,
}))`
	font-family: "NotoSans SemiBold";
	color: #721b0c;
	${PointerCursor};
`;

export const ForgotPasswordLink = styled(Asset.Link.withProps({
	fontSize: 24,
}))`
	font-family: "NotoSans ExtraBold";
	color: #72250C;
	text-align: left;
	text-decoration-line: underline;
`;

export const PlayButton = styled(Asset.Button.withProjection(btnPlayImg))`
	border: none;
	padding: 0;
`;

export const PlayButtonText = styled(Asset.Text.withProps({
	fontSize: 24,
	projection: PLAY_BTN_TEXT_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #4D2F1C;
	text-align: center;
	pointer-events: none;
`;

// endregion
